<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
   <loading
     :show="lshow"
     :label="llabel">
 </loading>
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Add Job | Master</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-primary card-outline">
		<div class="card-header">
			<h5>Add Job</h5>
		</div>
		<div class="card-body overflow-auto">
			<div class="col-sm-12">
				<div class="row">
					<div class="col-sm-3 center center-block" align="center">
						<button class="btn btn-danger" @click="nameMdl"><i class="fa fa-search"></i> Name</button>
					</div>
					<div class="col-sm-3 center center-block" align="center">
						<button class="btn btn-danger"  @click="codeMdl"><i class="fa fa-search"></i> Item Code</button>
					</div>
					<div class="col-sm-3 center center-block" align="center">
						<button class="btn btn-danger" @click="billMdl"><i class="fa fa-search"></i> Bill No.</button>
					</div>
					<div class="col-sm-3 center center-block" align="center">
						<button class="btn btn-danger" @click="slMdl"><i class="fa fa-search"></i> Sl/IMEI No.</button>
					</div>
					<div class="col-sm-3 center center-block" align="center">
						<button class="btn btn-danger" @click="jobMdl"><i class="fa fa-search"></i> Old Job</button>
					</div>
				</div>
			</div>
			<form @submit.prevent="addJob">
				<div :class="['form-group', errors.item_name ? 'has-error' : '']">
					<label>Item Name: *</label>
					<input type="text" class="form-control" placeholder="Enter the item name" v-model="form.item_name">
					<span v-if="errors.item_name" :class="['badge bg-danger']">Please enter the item name</span>
				</div>
				<div :class="['form-group', errors.item_code ? 'has-error' : '']">
					<label>Item Code:</label>
					<input type="text" class="form-control" placeholder="Enter the item code" v-model="form.item_code">
					<span v-if="errors.item_code" :class="['badge bg-danger']">Please enter the item code</span>
				</div>
				<div :class="['form-group', errors.brand ? 'has-error' : '']">
					<label>Brand: *</label>
					<input type="text" class="form-control" placeholder="Enter the brand" v-model="form.brand">
					<span v-if="errors.brand" :class="['badge bg-danger']">Please enter the brand</span>
				</div>
				<div :class="['form-group', errors.model ? 'has-error' : '']">
					<label>Model: *</label>
					<input type="text" class="form-control" placeholder="Enter the model" v-model="form.model">
					<span v-if="errors.model" :class="['badge bg-danger']">Please enter the model</span>
				</div>
				<div :class="['form-group', errors.category ? 'has-error' : '']">
					<label>Category: *</label>
					<v-select v-model="form.category" type="text" label="name" :options="categories" :reduce="categories => categories.name" placeholder="Select Item Category" :value="categories => categories.name"></v-select>
					<span v-if="errors.category" :class="['badge bg-danger']">Please choose category</span>
				</div>
				<div :class="['form-group', errors.type ? 'has-error' : '']">
					<label>Type: *</label>
					<input type="text" class="form-control" placeholder="Enter the serial no." v-model="form.type">
					<span v-if="errors.type" :class="['badge bg-danger']">Please enter the type</span>
				</div>
				<div :class="['form-group', errors.sl_no ? 'has-error' : '']">
					<label>Serial No.: *</label>
					<input type="text" class="form-control" placeholder="Enter the serial no." v-model="form.sl_no">
					<span v-if="errors.sl_no" :class="['badge bg-danger']">Please enter the serial no.</span>
				</div>
				<div :class="['form-group', errors.complaint ? 'has-error' : '']">
					<label>Complaint: *</label>
					<input type="text" class="form-control" placeholder="Enter the complaint" v-model="form.complaint">
					<span v-if="errors.complaint" :class="['badge bg-danger']">Please enter the complaint.</span>
				</div>
				<div :class="['form-group', errors.current_condition ? 'has-error' : '']">
					<label>Current Condition: *</label>
					<input type="text" class="form-control" placeholder="Enter the current condition" v-model="form.current_condition">
					<span v-if="errors.current_condition" :class="['badge bg-danger']">Please enter the current condition</span>
				</div>
				<div :class="['form-group', errors.accessories_received ? 'has-error' : '']">
					<label>Accessories Received:</label>
					<div class="form-check form-check-inline" v-for="a in accessories" :key="a.id">
  					<input class="form-check-input" type="checkbox" :id="a.accessory" :value="a.accessory" v-model="accessories_received" name="accessory">
  					<label class="form-check-label" :for="a.accessory">{{a.accessory}}</label>
					</div>
					<span v-if="errors.accessories_received" :class="['badge bg-danger']">Please enter the accessories received</span>
				</div>
				<div :class="['form-group', errors.description ? 'has-error' : '']">
					<label>Description/Password*:</label>
					<input type="text" class="form-control" placeholder="Enter the description" v-model="form.description">
					<span v-if="errors.description" :class="['badge bg-danger']">Please enter the description</span>
				</div>
				<div :class="['form-group', errors.purchased_year? 'has-error' : '']">
					<label>Purchased Date:</label>
					<input type="date" class="form-control" placeholder="Enter the year of purchase" v-model="form.purchased_year">
					<span v-if="errors.purchased_year" :class="['badge bg-danger']">Please enter a valid year.</span>
				</div>
				<div :class="['form-group', errors.oxygen_bought ? 'has-error' : '']">
					<label>Oxygen Bought:</label>
					<select class="form-control" placeholder="Oxygen Bought" v-model="form.oxygen_bought">
						<option value="Yes">Yes</option>
						<option value="No">No</option>
					</select>
					<span v-if="errors.oxygen_bought" :class="['badge bg-danger']">Please choose.</span>
				</div>
				<div :class="['form-group', errors.job_category ? 'has-error' : '']">
					<label>Job Category: *</label>
					<v-select placeholder="Job Category" v-model="form.job_category" :options="job_categories" :reduce="job_categories => job_categories.name" label="name"></v-select>
					<span v-if="errors.job_category" :class="['badge bg-danger']">Please choose a category.</span>
				</div>
				<div :class="['form-group', errors.purchased_from ? 'has-error' : '']">
					<label>Purchased From:</label>
					<input type="text" class="form-control" placeholder="Enter where the item was purchased from" v-model="form.purchased_from">
					<span v-if="errors.purchased_from" :class="['badge bg-danger']">Please enter a valid character.</span>
				</div>
				<div :class="['form-group', errors.bill_no ? 'has-error' : '']">
					<label>Bill No.:</label>
					<input type="text" class="form-control" placeholder="Enter the bill no." v-model="form.bill_number">
					<span v-if="errors.bill_no" :class="['badge bg-danger']">Please enter the bill no.</span>
				</div>
				<div :class="['form-group', errors.expected_delivery_date? 'has-error' : '']">
					<label>Expected Delivery:</label>
					<input type="date" class="form-control" placeholder="Enter expected delivery date" v-model="form.expected_delivery_date">
					<span v-if="errors.expected_delivery_date" :class="['badge bg-danger']">Please enter a valid date.</span>
				</div>
				<div :class="['form-group', errors.estimated_cost ? 'has-error' : '']">
					<label>Estimated Cost:</label>
					<input type="number" class="form-control" placeholder="Enter the estimated cost" v-model="form.estimated_cost" min="1">
					<span v-if="errors.estimated_cost" :class="['badge bg-danger']">Please enter the estimated cost.</span>
				</div>
                <label>Job Location:*</label>
                <br>
                <div :class="['form-check form-check-inline form-group', errors.job_location ? 'has-error' : '']">
					<input class="form-check-input" type="radio" name="exampleRadios12" id="exampleRadios1" value="Offsite" v-model="form.job_location">
					<label class="form-check-label" for="exampleRadios1">
						Offsite (brought to o2care)
					</label>
				</div>

				<div :class="['form-check form-check-inline form-group', errors.job_location ? 'has-error' : '']">
					<input class="form-check-input" type="radio" name="exampleRadios11" id="exampleRadios1" value="Onsite" v-model="form.job_location">
					<label class="form-check-label" for="exampleRadios1">
						Onsite (Home, other location etc.)
					</label>
					<span v-if="errors.job_location" :class="['badge bg-danger']">Please choose the job location.</span>
				</div>
                <br>
                <br>
				<div :class="['form-group', errors.expected_delivery_date? 'has-error' : '']">
					<button class="btn btn-danger" style="width:100% !important;" type="submit">Add Job to System</button>
				</div>
                <br>
                <br>

				<!--<div :class="['form-group', errors.customer_phone ? 'has-error' : '']">
					<label>Customer Phone:</label>
					<input type="number" class="form-control" placeholder="Enter customer phone number" v-model="form.customer_phone">
					<span v-if="errors.customer_phone" :class="['badge bg-danger']">Please enter customer phone number.</span>
					<button class="btn btn-danger"><i class="fa fa-search"></i> Search</button>
					<button class="btn btn-danger"><i class="fa fa-plus"></i> Add New</button>
				</div>
				<div :class="['form-group', errors.comm_address ? 'has-error' : '']">
					<label>Communication Address:</label>
					<select class="form-control" placeholder="Select Communication Address" v-model="form.comm_address">
						<option v-for="a in addresses" :value="a.id">{{a.addr_l1}}, {{a.addr_l2}}, {{a.addr_l3}}, {{a.city}}, {{a.state}}, {{a.pincode}}</option>
					</select>
					<span v-if="errors.comm_address" :class="['badge bg-danger']">Please choose an address.</span>
				</div>
				<div :class="['form-group', errors.billing_address ? 'has-error' : '']">
					<label>Billing Address:</label>
					<select class="form-control" placeholder="Select Billing Address" v-model="form.billing_address">
						<option v-for="a in addresses" :value="a.id">{{a.addr_l1}}, {{a.addr_l2}}, {{a.addr_l3}}, {{a.city}}, {{a.state}}, {{a.pincode}}</option>
					</select>
					<span v-if="errors.billing_address" :class="['badge bg-danger']">Please choose an address.</span>
				</div>-->

			</form>
		</div>
    <div class="card-footer">

		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->

<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="nameModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Search Using Name</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="col-sm-12 align-center center justify-content-center">
						<div class="row">
							<div class="col-sm-11 align-center center content-center">
								<div class="form-group">
								<input type="text" placeholder="Enter the brand" v-model="brand" class="form-control">
								</div>
							</div>
							<div class="col-sm-11 align-center center content-center">
								<div class="form-group">
								<input type="text" placeholder="Enter the model" v-model="model" class="form-control">
								</div>
							</div>
							<div class="col-sm-6">
								<div class="form-group">
								<button class="btn btn-info" @click="nameSearch">Search</button>
							</div>
							</div>
							<br>
							<div class="col-sm-11 align-center center content-center">
								<div class="form-group">
								<span class="right badge badge-success">{{search_status}}</span>
							</div>
							</div>

							<br>
						</div>
						</div>
						<div class="col-sm-12">
							<div class="form-group">
								<label>Choose Item:</label>
								<v-select v-model="item" type="text" label="ITEM_NAME" :options="items" :reduce="items => items.ITEM_CODE" placeholder="Select APX ITEM" :value="items => items.ITEM_CODE"></v-select>
							</div>
							<div class="form-group">
								<button class="btn btn-danger" @click="selectItem">Select</button>
							</div>
						</div>
					</div>
				</div>
				</div>
				</div>

<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="codeModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Search Using Item Code</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="col-sm-12">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group">
								<input type="text" placeholder="Enter the item code" v-model="code" class="form-control">
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-info" @click="codeSearch">Search ERP for Item</button>
								</div>
							</div>
							<br>
							<div class="form-group">
								<span class="right badge badge-success">{{search_status}}</span>
							</div>
							<br>
						</div>
						</div>
						<div class="col-sm-12">
							<div class="col-sm-12">
								<div class="form-group">
								<label>Choose Item:</label>
								<v-select class="form-control" v-model="item" type="text" label="ITEM_NAME" :options="items" :reduce="items => items.ITEM_CODE" placeholder="Select APX ITEM" :value="items => items.ITEM_CODE"></v-select>
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="selectItem">Select</button>
							    </div>
							</div>
						</div>
					</div>
				</div>
				</div>
				</div>


<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="billModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Search Using Bill No.</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="col-sm-12">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group">
								<input type="text" placeholder="Enter the bill number" v-model="bill" class="form-control">
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<input type="date" placeholder="Enter the bill date" v-model="bill_date" class="form-control">
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="billSearch">Search ERP for Item</button>
								</div>
							</div>
							<br>
							<div class="col-sm-12">
								<div class="form-group">
								<span class="right badge badge-success">{{search_status}}</span>
								</div>
							</div>
							<br>
						</div>
						</div>
						<div class="col-sm-12">
							<div class="col-sm-12">
								<div class="form-group">
								<label>Choose Item:</label>
								<v-select v-model="item" class="form-control" type="text" label="ITEM_NAME" :options="items" :reduce="items => items.ITEM_CODE" placeholder="Select APX ITEM" :value="items => items.ITEM_CODE"></v-select>
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="selectItem">Select</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
				</div>

	<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="jobModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Search Using Previoud Job Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="col-sm-12">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group">
								<input type="text" placeholder="Enter job no./sl no./phone no./item name matching old job" v-model="job_data" class="form-control">
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="jobSearch">Search Data</button>
								</div>
							</div>
							<br>
							<div class="col-sm-12">
								<div class="form-group">
								<span class="right badge badge-success">{{search_status}}</span>
								</div>
							</div>
							<br>
						</div>
						</div>
						<div class="col-sm-12">
							<div class="col-sm-12">
								<div class="form-group">
								<label>Choose Item:</label>
								<v-select v-model="job" class="form-control" label="job_title" :options="jobs" :reduce="jobs => jobs.id" placeholder="Select Job"></v-select>
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="selectJob">Select</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
				</div>

				<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="slModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Search Using Sl\IMEI No.</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="col-sm-12">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group">
								<input type="text" placeholder="Enter the SL/IMEI number" v-model="imei" class="form-control">
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="imeiSearch">Search ERP for Item</button>
								</div>
							</div>
							<br>
							<div class="col-sm-12">
								<div class="form-group">
								<span class="right badge badge-success">{{search_status}}</span>
								</div>
							</div>
							<br>
						</div>
						</div>
						<div class="col-sm-12">
							<div class="col-sm-12">
								<div class="form-group">
								<label>Choose Item:</label>
								<v-select v-model="item" class="form-control" type="text" label="ITEM_NAME" :options="items" :reduce="items => items.ITEM_CODE" placeholder="Select APX ITEM" :value="items => items.ITEM_CODE"></v-select>
								</div>
							</div>
							<div class="col-sm-12">
								<div class="form-group">
								<button class="btn btn-danger" @click="selectItem" data-dismiss="modal">Select</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
				</div>

<!-- All VUE Parts end before this comment -->

<!-- I have a bad feeling about this -->
        </div>
        <div v-if="!$gate.isServiceManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import loading from 'vue-full-loading';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {
            loading
        },

        created(){
        	this.getAccessories();
        	this.getCategories();
        	this.getJobCategories();
        },


        data(){
        	return {
        		form: new Form({
        			item_name: '',
        			item_code: '',
							brand: '',
        			model: '',
        			purchased_year: '',
        			category: '',
        			type: '',
        			expected_delivery_date: '',
        			job_category: '',
        			oxygen_bought: '',
        			bill_number: '',
        			sl_no: '',
        			complaint: '',
        			current_condition: '',
        			accessories_received: [],
        			purchased_from: '',
        			description: '',
        			estimated_cost: '',
        			imei: '',
        			job_location: ''
        		}),

        		errors: [],
        		brand: '',
        		model: '',
        		items: [],
        		item: '',
        		code: '',
        		search_status: '',
        		bill: '',
        		bill_date: '',
        		accessories: [],
        		accessories_received: [],
        		categories: [],
        		job_categories: [],
        		imei: '',
        		lshow: false,
           	llabel: 'Creating Job...',
           	job_data: '',
           	job: '',
           	jobs : []
        	}
        },

        methods: {
        	getVendors(){
        		axios.post("/api/getAllCategories")
        		.then(response => {
        			this.categories = response.data;
        		})
        	},

        	getAccessories(){
        		axios.post("/api/getAllAccessories")
        		.then(response => {
        			this.accessories = response.data;
        		})
        	},

        	getCategories(){
        		axios.post("/api/getAllCategories")
        		.then(response => {
        			this.categories = response.data;
        		})
        	},

        	getJobCategories(){
        		axios.post("/api/getAllJobCategories")
        		.then(response => {
        			this.job_categories = response.data;
        		})
        	},

        	addJob(){
        		this.form.accessories_received = this.accessories_received.toString();
        		this.lshow = true;
        		this.form.post("/api/addJob")
        		.then(response => {
        			if(response.data != null)
        				this.$router.push("/service-manager/add-job-customer/"+response.data);
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        		this.lshow = false;
        	},

        	nameMdl(){
        		this.search_status = '';
        		$("#nameModal").modal("show");
        	},

        	codeMdl(){
        		this.search_status = '';
        		$("#codeModal").modal("show");
        	},

        	billMdl(){
        		this.search_status = '';
        		$("#billModal").modal("show");
        	},

        	slMdl(){
        		this.search_status = '';
        		$("#slModal").modal("show");
        	},

        	jobMdl(){
        		this.search_status = '';
        		$("#jobModal").modal("show");
        	},

        	nameSearch(){
        		toast.fire({
        			icon: "warning",
        			title: "Searching!!!"
        		});
        		this.search_status = 'Searching...';
        		axios.post("/api/nameSearch", {brand: this.brand, model: this.model})
        		.then(response => {
        			this.items = response.data;
        			toast.fire({
        				icon: "success",
        				title: "Search Complete"
        			});
        			this.search_status = 'Search Complete!';
        		})
        		.catch(() => {
        			toast.fire({
        				icon: "error",
        				title: "Search Failed"
        			});
        			this.search_status = 'Search Complete!';
        		})
        	},

        	codeSearch(){
        		toast.fire({
        			icon: "warning",
        			title: "Searching!!!"
        		});
        		this.search_status = 'Searching...';
        		axios.post("/api/codeSearch", {code: this.code})
        		.then(response => {
        			this.items = response.data;
        			toast.fire({
        				icon: "success",
        				title: "Search Complete"
        			});
        			this.search_status = 'Search Complete!';
        		})
        		.catch(() => {
        			toast.fire({
        				icon: "error",
        				title: "Search Failed"
        			});
        			this.search_status = 'Search Complete!';
        		})
        	},

        	billSearch(){
        		toast.fire({
        			icon: "warning",
        			title: "Searching!!!"
        		});
        		this.search_status = 'Searching...';
        		axios.post("/api/billSearch", {bill: this.bill, bill_date: this.bill_date})
        		.then(response => {
        			this.items = response.data;
        			toast.fire({
        				icon: "success",
        				title: "Search Complete"
        			});
        			this.search_status = 'Search Complete!';
        		})
        		.catch(() => {
        			toast.fire({
        				icon: "error",
        				title: "Search Failed"
        			});
        			this.search_status = 'Search Complete!';
        		})
        	},

        	imeiSearch(){
        		toast.fire({
        			icon: "warning",
        			title: "Searching!!!"
        		});
        		this.search_status = 'Searching...';
        		axios.post("/api/imeiSearch", {imei: this.imei})
        		.then(response => {
        			this.items = response.data;
        			toast.fire({
        				icon: "success",
        				title: "Search Complete"
        			});
        			this.search_status = 'Search Complete!';
        		})
        		.catch(() => {
        			toast.fire({
        				icon: "error",
        				title: "Search Failed"
        			});
        			this.search_status = 'Search Complete!';
        		})
        	},

        	jobSearch(){
        		toast.fire({
        			icon: "warning",
        			title: "Searching!!!"
        		});
        		this.search_status = 'Searching...';
        		axios.post("/api/jobSearch", {data: this.job_data})
        		.then(response => {
        			this.jobs = response.data;
        			toast.fire({
        				icon: "success",
        				title: "Search Complete"
        			});
        			this.search_status = 'Search Complete!';
        		})
        		.catch(() => {
        			toast.fire({
        				icon: "error",
        				title: "Search Failed"
        			});
        			this.search_status = 'Search Complete!';
        		})
        	},

        	selectJob(){
        		var item = this.jobs.find(c => c.id == this.job);
        		this.form.fill(item);
        	},

        	selectItem(){
        		var item = this.items.find(c => c.ITEM_CODE == this.item);
        		this.form.item_name = item.ITEM_NAME;
        		this.form.item_code = item.ITEM_CODE;
        		var name = item.ITEM_NAME.split(":");
        		this.form.brand = name[0];
        		this.form.type = name[1];
        		this.form.model = name[2];
        		this.form.category = item.PROD_CATG_NAME;
        		this.form.sl_no = item.ITEM_SERIAL_NOS;

        		$("#nameModal").modal("hide");
        		$("#codeModal").modal("hide");
        		$("#billModal").modal("hide");
        	}
        }
    }
</script>
